// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"403":"4a73764f","488":"c42d63cd"}[chunkId] + ".chunk.js";
};